export default function getImagePath(url: string) {
  // If the URL is relative, return it as is
  if (!url.startsWith('http')) {
    return url
  }

  // Otherwise, parse the URL and return the pathname
  const parsedUrl = new URL(url)

  return parsedUrl.pathname.startsWith('/') ? parsedUrl.pathname.substring(1) : parsedUrl.pathname
}
